(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/data/channels.js'),
            require('../enums/colors.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js')
        );

    } else {
        RivalIQ.metrics.definitions.domain = exportFn(
            RivalIQ.data.channels,
            RivalIQ.enums.colors,
            RivalIQ.enums,
            RivalIQ.strings
        );
    }

    function exportFn(channels, colors, metricEnums, strings) {
        const channel = channels.get('domain');

        return {
            className: channel.get('channel'),
            format: channel.get('name'),
            name: channel.get('name'),
            title: {
                name: 'Title',
                description: strings.web_homepage_title_description
            },
            title_size: {
                name: 'Title Length',
                description: strings.web_title_len_desc
            },
            overview: {
                name: 'Meta Description',
                description: strings.web_homepage_meta_description_description
            },
            overview_size: {
                name: 'Meta Description Length',
                description: strings.web_meta_desc_len_desc
            },
            overview_size_rating: {
                name: 'Meta Description Size Rating',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.STRING,
                description: strings.web_meta_desc_len_rating_desc
            },
            keywords: {
                name: 'Meta Keywords',
                description: strings.web_homepage_meta_keywords_description
            }
        };
    }
})();
